/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { WebConfiguration as __Configuration } from '../web-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TerminalList } from '../models/terminal-list';
import { TerminalSearchOptions } from '../models/terminal-search-options';
import { Terminal } from '../models/terminal';

/**
 * All about the terminals
 */
@Injectable({
  providedIn: 'root',
})
class TerminalsService extends __BaseService {
  static readonly searchTerminalsPath = '/terminals/search';
  static readonly retrieveTerminalsPath = '/terminals/{uid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Search terminals, with pagination
   *
   * Search terminals, with pagination
   * @param params The `TerminalsService.SearchTerminalsParams` containing the following parameters:
   *
   * - `sortFieldName`: Indicates the field to use for sorting the data:
   *     * NAME : the terminal's name
   *
   * - `sortDirection`: Sort direction : ASC, DESC
   *
   * - `search`: The terminal search options object
   *
   * - `offset`: The list items offset
   *
   * - `limit`: The list items limit
   *
   * @return Success or Partial Content
   */
  searchTerminalsResponse(params: TerminalsService.SearchTerminalsParams): __Observable<__StrictHttpResponse<TerminalList | TerminalList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.sortFieldName != null) __params = __params.set('sortFieldName', params.sortFieldName.toString());
    if (params.sortDirection != null) __params = __params.set('sortDirection', params.sortDirection.toString());
    __body = params.search;
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/terminals/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TerminalList | TerminalList>;
      })
    );
  }
  /**
   * Search terminals, with pagination
   *
   * Search terminals, with pagination
   * @param params The `TerminalsService.SearchTerminalsParams` containing the following parameters:
   *
   * - `sortFieldName`: Indicates the field to use for sorting the data:
   *     * NAME : the terminal's name
   *
   * - `sortDirection`: Sort direction : ASC, DESC
   *
   * - `search`: The terminal search options object
   *
   * - `offset`: The list items offset
   *
   * - `limit`: The list items limit
   *
   * @return Success or Partial Content
   */
  searchTerminals(params: TerminalsService.SearchTerminalsParams): __Observable<TerminalList | TerminalList> {
    return this.searchTerminalsResponse(params).pipe(
      __map(_r => _r.body as TerminalList | TerminalList)
    );
  }

  /**
   * Retrieve a terminal
   *
   * Retrieve a terminal
   * @param uid The object ID. Must be a valid ID.
   * @return Success
   */
  retrieveTerminalsResponse(uid: string): __Observable<__StrictHttpResponse<Terminal>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/terminals/${encodeURIComponent(String(uid))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Terminal>;
      })
    );
  }
  /**
   * Retrieve a terminal
   *
   * Retrieve a terminal
   * @param uid The object ID. Must be a valid ID.
   * @return Success
   */
  retrieveTerminals(uid: string): __Observable<Terminal> {
    return this.retrieveTerminalsResponse(uid).pipe(
      __map(_r => _r.body as Terminal)
    );
  }
}

namespace TerminalsService {

  /**
   * Parameters for searchTerminals
   */
  export interface SearchTerminalsParams {

    /**
     * Indicates the field to use for sorting the data:
     *   * NAME : the terminal's name
     */
    sortFieldName?: 'NAME';

    /**
     * Sort direction : ASC, DESC
     */
    sortDirection?: 'ASC' | 'DESC';

    /**
     * The terminal search options object
     */
    search?: TerminalSearchOptions;

    /**
     * The list items offset
     */
    offset?: number;

    /**
     * The list items limit
     */
    limit?: number;
  }
}

export { TerminalsService }
